export default "__VITE_ASSET__BSgjrmMi__"